module.exports = __webpack_public_path__ + "files/c07b7e1c237abbb5b52bd84632ade0ad.png";